import { Link } from 'react-router-dom';
import PageContainer from '../components/page-container/PageContainer';

type ErrorSplashScreenProps = {
    smallScreen?: boolean;
    errorCode?: number;
    title?: string;
    redirectUrl?: string;
    redirectTitle?: string;
    leftArrow?: boolean;
    handleClick?: () => void;
};

export default function ErrorSplashScreen({
    smallScreen = false,
    errorCode = 500,
    title,
    redirectUrl = '#',
    redirectTitle,
    leftArrow = false,
    handleClick,
}: ErrorSplashScreenProps): JSX.Element {
    return (
        <PageContainer>
            <div className="flex min-h-full flex-col bg-white pt-16 pb-12">
                <main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-6 lg:px-8">
                    <div className="py-16">
                        <div className="text-center">
                            <p className="text-base font-semibold text-indigo-600">{errorCode}</p>
                            <h1
                                className={`mt-2 tracking-tight text-gray-900 ${
                                    smallScreen ? 'text-4xl font-medium' : 'text-4xl font-bold sm:text-5xl'
                                }`}
                            >
                                {title || 'Page not found.'}
                            </h1>
                            <p className="mt-2 text-base text-gray-500">
                                Sorry, we couldn&apos;t find the page you&apos;re looking for. Please contact your firm administrator.
                            </p>
                            <div className="mt-6">
                                {handleClick ? (
                                    <div
                                        className="text-base font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
                                        onClick={handleClick}
                                    >
                                        {leftArrow && <span aria-hidden="true">&larr; </span>}
                                        {redirectTitle || 'Select a different firm'}
                                        {!leftArrow && <span aria-hidden="true"> &rarr;</span>}
                                    </div>
                                ) : (
                                    <>
                                        <Link
                                            to={redirectUrl || '/onboarding?step=join-firm'}
                                            className="text-base font-medium text-indigo-600 hover:text-indigo-500"
                                        >
                                            {leftArrow && <span aria-hidden="true">&larr; </span>}
                                            {redirectTitle || 'Select a different firm'}
                                            {!leftArrow && <span aria-hidden="true"> &rarr;</span>}
                                        </Link>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
                <footer className="mx-auto w-full max-w-7xl flex-shrink-0 px-6 lg:px-8">
                    <nav className="flex justify-center space-x-4">
                        <a
                            href="https://support.cimplico.com"
                            target="_blank"
                            className="text-sm font-medium text-gray-500 hover:text-gray-600"
                            rel="noreferrer"
                        >
                            Contact Support
                        </a>
                    </nav>
                </footer>
            </div>
        </PageContainer>
    );
}
